import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const CurvedRectangleIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 76, height = 56, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 76 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M0 0H76H71.9497C57.2038 0 43.6538 8.11293 36.6905 21.1111L26.5 40.1334C21.2665 49.9025 11.0827 56 0 56V0Z"
          fill="#007EEB"
        />
      </svg>
    );
  },
);
